import styled from '@emotion/styled'

export const StylePhoneInputWrapper = styled.div<any>`
  border: 1px solid
    ${(props) =>
      props?.isFocus
        ? props.theme.colors.primary
        : props?.hasError
          ? props.theme.colors.danger
          : props.theme.colors.inputBorder};
  border-radius: 8px;
  height: 45px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding-right: 10px;
  position: relative;
  &:disabled {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }
`

export const StylePhoneInput = styled.input<any>`
  border: 0px;
  width: calc(100% - 50px);
  outline: none;
  padding: 0px;
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:disabled {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }

  -moz-appearance: textfield;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Poppins;
  }
`

export const StyleCountryCodeDropDown = styled.div<any>`
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }
`

export const StyleSelectedCountryCode = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.primaryTextColor};
  &:disabled {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }
`

export const StyleDropDownOptionWrapper = styled.div<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 11;
  top: 80px;
`
export const StyleDropDownOptionItems = styled.ul<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  max-height: 150px;
  overflow-y: auto;
`
export const StyleDropDownOption = styled.li<any>`
  padding: 7px 10px;
  font-size: 12px;
  background: ${(props) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.isActive ? props.theme.colors.white : props.theme.colors.black};
  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyleDropDownSearchWrapper = styled.div<any>`
  padding: 10px 10px;
`
export const StyleDropDownSearchInput = styled.input<any>`
  width: 100%;
  border-radius: 4px;
  height: 40px;
  text-indent: 10px;
  padding: 0px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Poppins;
  }
`
